export enum BorderWidthToken {
  widthNone = 'none',
  widthHairline = '0.1rem',
  widthThin = '0.2rem',
  widthThick = '0.4rem',
  widthHeavy = '0.8rem',
}

export default BorderWidthToken

export type TWidth =
  | 'widthNone'
  | 'widthHairline'
  | 'widthThin'
  | 'widthThick'
  | 'widthHeavy'
